<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- Current page title — see `AppNavbarVerticalLayout.vue`'s matching
           comment for why this replaced the old bookmark icons here too. -->
      <page-title />
    </div>

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <locale /> -->
      <dark-toggler class="d-none d-lg-block" />
      
      <!-- <punch-attendance /> -->
      <!-- <cart-dropdown /> -->
      <notification-dropdown />
      <!-- <search-bar /> -->
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import PageTitle from './components/PageTitle.vue'
//import Locale from './components/Locale.vue'
import DarkToggler from './components/DarkToggler.vue'
// import PunchAttendance from './components/PunchAttendance.vue'
// import SearchBar from './components/SearchBar.vue'
// import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    PageTitle,
    // Locale,
    DarkToggler,
    // PunchAttendance,
    // SearchBar,
    // CartDropdown,
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

}
</script>
